import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const SpanCurrency = styled.span`
	color: ${CONFIG.inputs.color};
	font-family: ${CONFIG.inputs.fontFamily};
	font-size: ${CONFIG.inputs.fontSize};
`;
